<canvas class="chart-canvas" [id]="'day-end-balance-chart' + index" height="400"> </canvas>
